import { ChevronDownIcon, ChevronUpIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import { Button } from "../../../../../../shared/components/button/Button";

const ObjectiveTrackerCollapseButton = ({
  isDisabled = false,
  onClickHandler,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <>
      {isDisabled ? (
        <Button size="icon" variant="ghost" disabled>
          <ChevronDownIcon className="h-4 w-4" />
        </Button>
      ) : (
        <Button
          aria-haspopup="true"
          size="icon"
          variant="ghost"
          onClick={() => {
            setIsCollapsed(!isCollapsed);
            onClickHandler();
          }}
        >
          {isCollapsed ? (
            <ChevronDownIcon className="h-4 w-4" />
          ) : (
            <ChevronUpIcon className="h-4 w-4" />
          )}
          <span className="sr-only">Toggle menu</span>
        </Button>
      )}
    </>
  );
};

export default ObjectiveTrackerCollapseButton;
